module.exports = __webpack_public_path__ + "img/Slide23.30384b49.png";